const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/eCheckin/components/fields/BirthDateField.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { useIntl } from 'react-intl';
import { MessageDescriptor } from '@formatjs/intl';
import { validateAHV, ValidationFunction } from '@cistec/common_web/components/Forms/utils/validation';
import { CIS4mDatePicker } from '@cistec/common_web/modules/CIS4m/components/CIS4mDatePicker';
import moment from 'moment';

interface Props {
    label: string | MessageDescriptor;
    path: string;
    checkValidity?: ValidationFunction;
    hidden?: boolean;
    required?: boolean;
}

export const BirthDateField = forwardRef((props: Props, ref: any) => {
    const { formatMessage } = useIntl();

    const datePickerFieldRef = useCIS4m(ref);

    const label = typeof props.label === 'string' ? props.label : formatMessage(props.label);
    const hidden = props.hidden ?? false;
    const required = props.required ?? false;

    const checkValidity = props.checkValidity ?? validateAHV;

    return (
        <CIS4mDatePicker
            ref={datePickerFieldRef}
            label={label}
            path={props.path}
            maxDate={moment()}
            hidden={hidden}
            required={required}
        />
    );
});

BirthDateField.displayName = 'BirthDateField';
